import React from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { MetricsGrid } from '../components/sections/MetricsGrid';
export function ImpactMetricsPage() {
  return <div data-id="element-258" data-mp="2h2ykm44rhj4y">
      <PageHeader eyebrow="Executive Impact & Capital Metrics" title="Quantifiable Enterprise Achievements" description="A high-impact metric showcase spanning capital deployment, innovation scale, and civic impact." data-id="element-259" data-mp="2h3hucxk9d17w" />
      <section className="bg-white pb-20 lg:pb-28" data-id="element-260" data-mp="1oekpbw5250x3">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-261" data-mp="1kd7greakyjmh">
          <MetricsGrid data-id="element-262" data-mp="1kesetdw3skp3" />
        </div>
      </section>
    </div>;
}